module.exports = require('./atmosphere');



//////////////////
// WEBPACK FOOTER
// ../~/atmosphere.js/lib/browser.js
// module id = 303
// module chunks = 10